import styled from "styled-components";

const Wrapper = styled.span`
  h1.light {
    background-image: linear-gradient(
      to right,
      #f97316,
      #b45309,
      #854d0e,
      #4d7c0f,
      #047857,
      #eab308,
      #3730a3,
      #6b21a8,
      #86198f,
      #9f1239
    );
  }
  h1.dark {
    background-image: linear-gradient(
      to right,
      #fed7aa,
      #fef08a,
      #d9f99d,
      #bbf7d0,
      #99f6e4,
      #a5f3fc,
      #bfdbfe,
      #ddd6fe,
      #f5d0fe,
      #fecdd3
    );
  }
  h1 {
    display: inline-block;
    margin: 0;
    padding: 0;

    color: transparent;
    -webkit-background-clip: text;
    animation: animate 20s linear infinite;
    background-size: 1000%;
    @keyframes animate {
      0% {
        background-position: 0% 100%;
      }
      5% {
        background-position: 100% 0%;
      }
      100% {
        background-position: 0% 100%;
      }
    }
  }
`;
export default Wrapper;
